import { useCallback, useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";

export const agentError = (e) => e.response?.data?.detail ? formatApiErrorDetail(e.response.data.detail) : (e.message || "No se pudo completar la solicitud.");
export const newId = () => crypto.randomUUID();
export const adminAgent = "/admin/agent";

export function useAgentData(path) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const load = useCallback(async () => {
    try { const res = await api.get(adminAgent + path); setData(res.data); setError(""); return res.data; }
    catch (e) { setError(agentError(e)); }
  }, [path]);
  useEffect(() => { setData(null); load(); }, [load]);
  return { data, setData, error, setError, load };
}

export async function copyText(text) { await navigator.clipboard.writeText(text); }